import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HeaderService } from './header.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})

export class SelfEnrollService {

  constructor(private http: HttpClient, private headerService: HeaderService, private authService: AuthService) { }

  preEnroll(user: any) {
    const url = `${environment.rootApiUrl}/selfEnroll/preEnroll`;
    let headers = this.headerService.getXAuthHeaderFromCookie();
    headers = headers.set('Content-Type', 'application/json');

    return this.http.post(url, user, { headers: headers, responseType: 'text' });
  }

  checkVerification(code: string) {
    const url = `${environment.rootApiUrl}/selfEnroll/verifyEmail`;

    let params = new HttpParams();
    params = params.append('verificationCode', code);

    return this.http.post(url, params, { headers: this.headerService.getXAuthHeaderFromCookie(), responseType: 'text' });
  }

}
